export enum EStatus {
  ACTIVE = 1,
  INACTIVE = 2
}

export enum EStatusLabel {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive'
}

export enum ReviewOption {
  SUPERVISOR_SIGNOFF = 1,
  ACKNOWLEDGEMENT = 2,
}

export const REVIEW_OPTION_LABELS = {
  [ReviewOption.SUPERVISOR_SIGNOFF]: 'Require supervisor signoff',
  [ReviewOption.ACKNOWLEDGEMENT]: 'Require acknowledgement',
} as const

export enum EPracticeItemType {
  STATION = 'station',
  SEGMENT = 'segment',
  LANE = 'lane'
}

export enum EPracticeDestinationType {
  PERIOD = 'period',
  LANE = 'lane',
  SEGMENT = 'segment'
}

export enum EMovePosition {
  BEGINNING = 'beginning',
  END = 'end'
}

export enum ESwitchState {
  ON = 'ON',
  OFF = 'OFF'
}

export const PRACTICE_ITEM_TYPE_LABELS = {
  [EPracticeItemType.STATION]: 'Station',
  [EPracticeItemType.SEGMENT]: 'Block',
  [EPracticeItemType.LANE]: 'Lane'
} as const

export const PRACTICE_DESTINATION_TYPE_LABELS = {
  [EPracticeDestinationType.PERIOD]: 'Period',
  [EPracticeDestinationType.LANE]: 'Lane',
  [EPracticeDestinationType.SEGMENT]: 'Block'
} as const

export const MOVE_POSITION_LABELS = {
  [EMovePosition.BEGINNING]: 'Beginning of the list',
  [EMovePosition.END]: 'End of the list'
} as const

// Assignee Type enum (match với backend) — only 'player' and 'coach'; groups expand to individual profiles at assign-time
export enum EAssigneeType {
  PLAYER = 'player',
  COACH = 'coach',
}

export const ASSIGNEE_TYPE_LABELS = {
  [EAssigneeType.PLAYER]: 'User',
  [EAssigneeType.COACH]: 'Coach',
} as const